import React, { useEffect, useState } from "react";
import "../../../css/VUP_dash.css";
import { FxmsData } from "../../datas/FxData";
import { FxValueDetail } from "./FxValueDetail"
import { FxAlarmDetail } from "./FxAlarmDetail"

export const MngTgModal = (props) => {
  const { plantObj } = props;
  const [clickedTab, setClickedTab] = useState("");
  const [dataObj, setDataObj] = useState({});
  let isShow = "chartList";
  // let moTid = plantObj?.devicePid ? plantObj?.devicePid : plantObj?.moTid;
  let moTid = plantObj?.devicePid ? plantObj?.devicePid : dataObj.devicePid
  let moNo = plantObj?.moNo ? plantObj?.moNo : dataObj?.moNo;
  let data_2_1 = { moTid: moTid, moNo: moNo };
  let data_2_2 = { moTid: moTid };


  useEffect(() => {
    console.log("plantObj>>", plantObj);
    setClickedTab(isShow);

    if (moNo !== undefined && moNo !== "") {
      getDataList();
    } else return;
  }, []);

  useEffect(() => {
    if (moNo !== undefined && moNo !== "") {
      getDataList();
    } else return;
  }, [moNo]);

  useEffect(() => {
    // console.log("dataObj>>", dataObj);
  }, [clickedTab, dataObj]);

  async function getDataList() {
    const param = { moNo: moNo };
    const uri = "fxMo/detail/base/"
    const response = await FxmsData.GET(uri.concat(param.moNo));
    console.log("response>>", response);
    // console.log("response.data>>", response.data[0]);
    setDataObj(response.data[0])
  }


  function toggleOnClass(event) {
    let clicked = event.currentTarget.id;
    const liElements = event.currentTarget.parentNode.children;
    for (let i = 0; i < liElements.length; i++) {
      liElements[i].classList.remove("on");
    }
    event.currentTarget.classList.add("on");
    setClickedTab(clicked);
  }

  return (
    <>
      {plantObj ? (<>
        <>
          <h1>관리대상 상세보기</h1>
          <div className="default">

            <table className="align1c align3c">
              <colgroup>
                <col style={{ width: "8%" }} />
                <col style={{ width: "16%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "16%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "16%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "16%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>명칭</th>
                  <td>{dataObj?.moDispName}</td>
                  <th>분류</th>
                  <td>{dataObj?.moClass}</td>
                  <th>유형</th>
                  <td>{dataObj?.moType}</td>
                  <th>설치위치</th>
                  <td>{dataObj?.inloName}</td>
                </tr>
                <tr>
                  <th>배관/설비</th>
                  <td>{dataObj?.facPipe}</td>
                  <th>설치일</th>
                  <td>{dataObj?.instYmd}</td>
                  <th>점검일</th>
                  <td>{dataObj?.mntnDate}</td>
                  <th>모델</th>
                  <td>{dataObj?.modelName}</td>
                </tr>
              </thead>
            </table>

            <div className="pop_topline">
              <div className="tabGroup">
                <ul>
                  <li id="chartList"
                    className={clickedTab === "chartList" ? "on" : ""}
                    onClick={(event) => { toggleOnClass(event) }}
                  > 수집데이터
                  </li>
                  <li id="eventList"
                    className={clickedTab === "eventList" ? "on" : ""}
                    onClick={(event) => { toggleOnClass(event) }}
                  > 이벤트
                  </li>
                </ul>
              </div>
            </div>
            <div className="factory_DataBox mngtg">
              {/* 탭 컴포넌트 */}
              {clickedTab === "chartList" && <FxValueDetail datas={data_2_1} />}
              {clickedTab === "eventList" && <FxAlarmDetail datas={data_2_2} />}
            </div>

          </div>
        </>
      </>) : null}
    </>

  );
}

